<template>
  <b-input-group size="lg" class="base-data-table-search">
    <template v-slot:prepend>
      <b-icon icon="search" :scale="0.875"></b-icon>
    </template>

    <BaseSearchInput
      :value="search"
      class="py-1 px-0 pr-3 border-0"
      @input="(newSearch) => setSearch(newSearch)"
    />
  </b-input-group>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'

import { BaseSearchInput } from '@components/base'

import { BaseDataTableInjectionKey } from './BaseDataTable.constants'

export default defineComponent({
  name: 'BaseDataTableSearchInput',
  components: {
    BaseSearchInput
  },
  setup() {
    const { search, setSearch } = inject(BaseDataTableInjectionKey)

    return {
      search,
      setSearch
    }
  }
})
</script>

<style scoped>
.input-group {
  width: 600px;
  border-radius: 32px;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  overflow: hidden;
}

.input-group .input-group-prepend {
  color: #adb5bd;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.input-group .form-control {
  height: 36px;
}
</style>
